import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography, Alert, Fade } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';

const PaymentModal = ({ open, onClose, product, onConfirm }) => {
    const [processing, setProcessing] = useState(false);
    const [success, setSuccess] = useState(false);

    const handlePay = () => {
        setProcessing(true);
        // Simulate API call
        setTimeout(() => {
            setProcessing(false);
            setSuccess(true);
            setTimeout(() => {
                onConfirm();
                setSuccess(false); // Reset for next time
            }, 2000);
        }, 1500);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CreditCardIcon color="primary" /> {success ? 'Payment Successful!' : 'Secure Payment'}
            </DialogTitle>
            <DialogContent>
                {success ? (
                    <Fade in={true}>
                        <Box sx={{ textAlign: 'center', p: 3 }}>
                            <Typography variant="h5" color="success.main" gutterBottom>
                                Order Placed!
                            </Typography>
                            <Typography variant="body1">
                                Your <strong>{product?.name}</strong> is on the way.
                            </Typography>
                        </Box>
                    </Fade>
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        {product && (
                            <Box sx={{ p: 2, bgcolor: 'action.hover', borderRadius: 2, mb: 1 }}>
                                <Typography variant="subtitle2">Purchasing:</Typography>
                                <Typography variant="h6">{product.name} - ${product.price}</Typography>
                            </Box>
                        )}

                        <TextField label="Card Number" placeholder="0000 0000 0000 0000" fullWidth variant="outlined" />
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <TextField label="Expiry" placeholder="MM/YY" fullWidth />
                            <TextField label="CVC" placeholder="123" fullWidth />
                        </Box>
                        <TextField label="Cardholder Name" placeholder="John Doe" fullWidth />

                        <Alert severity="info" sx={{ mt: 1 }}>This is a secure mock payment gateway.</Alert>
                    </Box>
                )}
            </DialogContent>
            {!success && (
                <DialogActions sx={{ p: 3 }}>
                    <Button onClick={onClose} color="inherit">Cancel</Button>
                    <Button
                        onClick={handlePay}
                        variant="contained"
                        color="primary"
                        size="large"
                        disabled={processing}
                        sx={{ px: 4 }}
                    >
                        {processing ? 'Processing...' : `Pay $${product?.price}`}
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
};

export default PaymentModal;
